//import React from "react";
import React, { useEffect, useState } from "react";
import Footer from "components/Footer/Footer";
import Admin from "layouts/Admin";
//import validator from 'validator'
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";

import firebase from "../firebase";

const assigncompanyupdate=(props)=> {

//Stroring Reteriwing Data
const [firstname, setFirstName] = useState("");
const [lastname, setLastName] = useState("");
const [Phone, setAPhone] = useState("");
const [Company, setACompany] = useState("");


 useEffect(()=>{

//  setID(props.match.params.id)
 const files = firebase.database().ref("StaffDriver").child(props.match.params.id);
  files.on('value', (snapshot)=>{
    const dataList = snapshot.val();
   
    setFirstName(dataList?.FName);
    setLastName(dataList?.LName);
    setAPhone(dataList?.Phone);
    setACompany(dataList?.Company);
   
    
  }) 


 },[]);

 const updateData = (e) => {
  // var email = email;   
       
  // if (validator.isEmail(email)) {
          // setEmailError(false);
  
  console.log(props.match.params.id)
  const files = firebase.database().ref("StaffDriver").child(props.match.params.id);
  
  let data = {
    
    FName:firstname,
    LName:lastname,
    Phone: Phone,
    Company:Company,
    
    
  };
  files.update(data);
  alert("Succfully Updated");
  
  setFirstName("");
  setLastName("");
  setAPhone("");
  setACompany("");
 
  

// }
            
//   else {
//           setEmailError(false);  
//   } 
 }

    return (
        <>

<Admin/>

<br/>

<Container>
  <Row>
    <Col md={{ span: 12, offset: 1 }}>  

      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Assign a company</Card.Title>
                <Form className="d-flex">
     
    </Form>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col className="pr-1" md="5">
                      <Form.Group>
                        <label>First Name</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="firstname"
                          type="text"
                          readOnly
                          focus value = {firstname} onChange={(e)=>{setFirstName (e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="3">
                      <Form.Group>
                        <label>Last Name</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="lastname"
                          readOnly
                          type="text"
                          focus value = {lastname} onChange={(e)=>{setLastName(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label htmlFor="exampleInputEmail1">
                           Phone
                        </label>
                        <Form.Control
                          placeholder="starting time"
                           readOnly
                          type="text"
                          focus value = {Phone} onChange={(e)=>{setAPhone(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                 
                  <Row>
                    
                    



                  <Col className="pr-1" md="5">
                      <Form.Group>
                        <label>Company</label>
                        <Form.Control
                          focus value = {Company} onChange={(e)=>{setACompany(e.target.value)}}
                          placeholder="Company"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>







                  </Row>

                  <Button onClick={(e)=>updateData()} variant="primary" size="" active>
                  Submit
                </Button>{' '}

                </Form>
              </Card.Body>
            </Card>
          </Col>
          
        </Row>
      </Container>

      </Col>
  </Row>
</Container>

<Footer /> 

    </>

     ) ;
    }



export default assigncompanyupdate;